import {
  Bell, Calendar, Collection, DataAnalysis, Document, Goods, Grid, House,
  Link, Promotion, Search, Service, Setting, ShoppingCart, User, Wallet
} from "@element-plus/icons-vue";
import type { NavIcon } from "@wjbk/workbench-contracts";

export const navigationIcons = { Bell, Calendar, Collection, DataAnalysis, Document, Goods, Grid, House,
  Link, Promotion, Search, Service, Setting, ShoppingCart, User, Wallet } satisfies Record<NavIcon, unknown>;

export function navigationIcon(name: NavIcon) { return navigationIcons[name]; }
